import React, { FC } from 'react';

const MediathekFooter: FC = ({ children }) => {
  return <div className="mediathek__footer">{children}</div>;
};

export default MediathekFooter;
